import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { FileUploadModule, FileUploadHandlerEvent } from 'primeng/fileupload';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { ToastModule } from 'primeng/toast';
import { ProgressBarModule } from 'primeng/progressbar';
import { BadgeModule } from 'primeng/badge';
import { MessageService } from 'primeng/api';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { Subscription } from 'rxjs';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatButtonModule } from '@angular/material/button';



@Component({
  selector: 'app-file-picker-sheet',
  standalone: true,
  imports: [
    CommonModule, FileUploadModule, TableModule, ButtonModule, ToastModule,
    ProgressBarModule, BadgeModule, MatExpansionModule,
    MatIconModule,MatButtonModule,
    MatProgressBarModule
  ],
  templateUrl: './file-picker-sheet.component.html',
  styleUrls: ['./file-picker-sheet.component.scss'],
  providers: []
})
export class FilePickerSheetComponent {


  currentState: { status: string; data?: any; error?: any } = { status: 'loading' };
  fileName: string;
  private uploadSubscription!: Subscription;

  constructor(
    private _sheetRef: MatBottomSheetRef<FilePickerSheetComponent>,
    @Inject(MAT_BOTTOM_SHEET_DATA) private data: any
  ) {
    this.fileName = data.fileName;
  }

  ngOnInit(): void {
    this.uploadSubscription = this.data.uploadState$.subscribe((state: any) => {
      this.currentState = state;
      console.log('state_____', state);

      if (state.status !== 'loading') {
        this._sheetRef.disableClose = false;
      }
    });
  }

  ngOnDestroy(): void {
    // Buena práctica para evitar fugas de memoria
    if (this.uploadSubscription) {
      this.uploadSubscription.unsubscribe();
    }
  }

  closeSheet(): void {
    this._sheetRef.dismiss({ changes: true });
  }
}